import { render, staticRenderFns } from "./UserCoinsComponent.vue?vue&type=template&id=3cd61464&scoped=true"
import script from "./UserCoinsComponent.vue?vue&type=script&lang=js"
export * from "./UserCoinsComponent.vue?vue&type=script&lang=js"
import style0 from "./UserCoinsComponent.vue?vue&type=style&index=0&id=3cd61464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd61464",
  null
  
)

export default component.exports